// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.pedia-assistant.pedia-assistant__wrapper[data-v-76dcc788] .pedia-assistant__overlay{z-index:99999}", ""]);
// Exports
module.exports = exports;
